export enum BranchesRestrictionFields {
  TITLE = 'title',
  BRANCH_ID = 'branchId',
  SORT = 'sort',
  STORE_TRACKING_CODE = 'store.trackingCode',
}
